class Langify {
    static async translate(words, languageTo) {
        try {
            return words;
        }
        catch (e) {
            console.error({
                msg: 'cannot translate using weglot', params: { words: words, languageTo: languageTo },
                langifyInput: {}
            });
        }
    }
    static getCurrentLanguage() {
        try {
            return (window?.langify?.locale?.iso_code) ?? 'en';
        }
        catch (e) {
            console.error({
                msg: 'cannot get language using langify'
            });
        }
    }
    static getProductUrl(productUrl) {
        try {
            if (!(window?.langify?.locale?.language_id) ||
                (window?.langify?.locale?.root_url === "/")) {
                return productUrl;
            }
            if (window?.langify?.locale?.root_url) {
                if (productUrl && productUrl.length > 0) {
                    if (productUrl.slice(0, 1) === '/') {
                        return window?.langify?.locale?.root_url + productUrl;
                    }
                    else {
                        return window?.langify?.locale?.root_url + '/' + productUrl;
                    }
                }
                else {
                    return window?.langify?.locale?.root_url + '/' + productUrl;
                }
            }
            return productUrl;
        }
        catch (e) {
            console.error({
                msg: 'cannot getProductUrl',
                productUrl: productUrl,
                langify: window?.langify
            });
        }
    }
    static getStoreId() {
        try {
            if (window?.langify?.locale?.language_id?.length > 1) {
                let storeId = window?.langify?.locale?.language_id?.slice(2, window?.langify?.locale?.language_id?.length);
                return Number(storeId);
            }
            else {
                return null;
            }
        }
        catch (e) {
            console.error({
                msg: 'cannot getStoreId',
                langify: window?.langify
            });
        }
    }
    static getTranslatedUrl(url) {
        const hasProtocol = url.includes("http://") || url.includes("https://");
        try {
            const translatedUrl = new URL(hasProtocol ? url : `${window?.location?.origin}/${(url.slice(0, 1) === '/') ? url.slice(1) : url}`);
            if (window?.langify?.locale?.root_url &&
                window?.langify?.locale?.root_url !== "/" &&
                !translatedUrl.pathname.includes(window?.langify?.locale?.root_url)) {
                if (translatedUrl.pathname.slice(0, 1) === '/') {
                    translatedUrl.pathname = window?.langify?.locale?.root_url + translatedUrl.pathname;
                }
                else {
                    translatedUrl.pathname = window?.langify?.locale?.root_url + '/' + translatedUrl.pathname;
                }
            }
            if (hasProtocol) {
                return translatedUrl.href;
            }
            return translatedUrl.pathname;
        }
        catch (e) {
            console.error({
                msg: 'cannot getLangifyUrl',
                url: url,
                langify: window?.langify
            });
        }
    }
}
export { Langify };
//# sourceMappingURL=Langify.js.map